import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import Hls from 'hls.js';
import { VideoService } from 'src/app/aplication/service/video.service';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.scss'
})
export class VideoPlayerComponent {
  @Input() lessonId!: string;
  @ViewChild('videoElement', { static: false }) videoElement!: ElementRef<HTMLVideoElement>;

  private hls: Hls | null = null;
  
  videoUrl: string = '';
  isLoading: boolean = true;
  errorMessage: string = '';
  isVideoReady: boolean = false;
  availableLevels: any[] = [];
  selectedLevel: number = -1; // -1 = auto

  constructor(private videoService: VideoService) {}

  ngOnInit(): void {
    this.loadVideo();
  }

  ngOnDestroy(): void {
    this.destroyPlayer();
  }

  async loadVideo(): Promise<void> {
    try {
      this.isLoading = true;
      this.errorMessage = '';

      // Busca informações do vídeo usando o service
      const response = await this.videoService.getVideoInfo(this.lessonId).toPromise();

      if (response?.success && response.data.isReady) {
        this.isVideoReady = true;
        
        // Busca URL de playback usando o service
        const playbackResponse = await this.videoService.getPlaybackUrl(this.lessonId).toPromise();
        console.log('A URL do vídeo é: ' + playbackResponse?.hlsUrl);

       if (playbackResponse?.hlsUrl) {
          this.videoUrl = playbackResponse.hlsUrl;
          // Aguarda a renderização do DOM
          setTimeout(() => this.initializePlayer(), 100);
        }
      } else {
        this.errorMessage = 'Vídeo ainda não está disponível. Aguarde o processamento.';
      }
    } catch (error: any) {
      this.errorMessage = error?.error?.message || 'Erro ao carregar vídeo';
      console.error('Erro ao carregar vídeo:', error);
    } finally {
      this.isLoading = false;
    }
  }
 
  private initializePlayer(): void {
    const video = this.videoElement.nativeElement;

    if (Hls.isSupported()) {
      this.hls = new Hls({
        debug: false,
        enableWorker: true,
        lowLatencyMode: true,
      });

      this.hls.loadSource(this.videoUrl);
      this.hls.attachMedia(video);

      // ✅ PONTO CERTO: capturar níveis aqui
      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        console.log("Manifest carregado.");

        // Captura resoluções disponíveis
        this.availableLevels = this.hls!.levels.map((level: any, index: number) => ({
          index,
          height: level.height
        }));

        console.log("Resoluções disponíveis:", this.availableLevels);
      });

      this.hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("Erro no HLS:", data);
        if (data.fatal) {
          this.errorMessage = 'Erro fatal ao reproduzir vídeo';
          this.destroyPlayer();
        }
      });

    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // ✅ Safari (não suporta troca manual de resolução)
      video.src = this.videoUrl;
    } else {
      this.errorMessage = 'Navegador não suporta reprodução HLS';
    }
  }

changeQuality(levelIndex: number): void {
  if (!this.hls) return;

  this.selectedLevel = levelIndex;

  if (levelIndex === -1) {
    // AUTO
    this.hls.currentLevel = -1;
    console.log("Qualidade automática ativada");
  } else {
    // QUALITY MANUAL
    this.hls.currentLevel = levelIndex;
    console.log("Qualidade definida para:", levelIndex);
  }
}

  private destroyPlayer(): void {
    if (this.hls) {
      this.hls.destroy();
      this.hls = null;
    }
  }

  retry(): void {
    this.loadVideo();
  }
}